import React, { createContext, useState, useContext, useEffect } from 'react';
import BeatmatchBackendClient from '../BeatmatchBackendClient';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing token and validate it
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        if (token) {
          const userData = await BeatmatchBackendClient.getUser();
          setUser(userData?.user);
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        localStorage.removeItem('accessToken');
      } finally {
        setLoading(false);
      }
    };
    
    checkAuth();
  }, []);

  const login = async (email, password) => {
    const response = await BeatmatchBackendClient.login(email, password);
    const { accessToken } = response.login;
    localStorage.setItem('accessToken', accessToken);
    const userData = await BeatmatchBackendClient.getUser();
    setUser(userData?.user);
    return response;
  };

  const logout = async () => {
    await BeatmatchBackendClient.logout();
    localStorage.removeItem('accessToken');
    setUser(null);
  };

  const signup = async (email, password, firstName, lastName) => {
    const response = await BeatmatchBackendClient.signUp(email, password, firstName, lastName);
    const { accessToken } = response.signup;
    localStorage.setItem('accessToken', accessToken);
    const userData = await BeatmatchBackendClient.getUser();
    setUser(userData?.user);
    return response;
  }

  const value = {
    user,
    login,
    logout,
    loading,
    signup
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 